import { OnInit } from '@angular/core';

export abstract class DropDownComponentBase<T> implements OnInit {
    nullValue = null;
    isLoadingItems: boolean;
    isDisabled: boolean;
    items: T[];

    private selectedItemValue: T = null;

    constructor() { }

    ngOnInit() {
        this.updateItemList();
    }

    protected abstract getItems(): Promise<T[]>;
    protected abstract mapItem(items: T[], item: T): T;
    protected abstract onItemSelected(item: T);
    protected setSelectedItem(item: T) {
        if (this.items) {
            this.selectedItemValue = item ? this.mapItem(this.items, item) : null;
        } else {
            this.selectedItemValue = item;
        }
        this.onItemSelected(this.selectedItemValue);
    }
    protected updateItemList() {
        this.items = null;
        let getItemsPromise = this.getItems();
        if (getItemsPromise instanceof Promise) {
            this.isLoadingItems = true;
            getItemsPromise.then(items => {
                this.items = items;
                this.selectedItemValue = this.selectedItemValue ? this.mapItem(this.items, this.selectedItemValue) : null;
                this.isLoadingItems = false;
            });
        }
    }

    getDisplayValue(item: T) {
        return item['name'];
    }

    get selectedItem() {
        return this.selectedItemValue;
    }
    set selectedItem(val: T) {
        this.selectedItemValue = val;
        if (val == this.nullValue) {
            this.onItemSelected(null);
        } else {
            this.onItemSelected(val);
        }
    }

}

export interface IDropDownItem {
    displayValue: string;
    value: any;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/drop-down.base.component.ts